const getGeometrySinglePointCoordinates = coordinates => {
  let pointCoordinates = coordinates;
  while (Array.isArray(pointCoordinates[0])) {
    pointCoordinates = pointCoordinates[0];
  }
  return pointCoordinates;
};

export default getGeometrySinglePointCoordinates;
